export const SEARCH_STATUSES = {
    UNKNOWN: 'unknown',
    SEARCHING_OTHER_CAMPAIGN: 'searching-other-campaign',
    SEARCHING_CURRENT_CAMPAIGN: 'searching-current-campaign',
    NOT_SEARCHING: 'not-searching',
    SEARCH_COMPLETE: 'search-complete',
    SEARCH_ERROR: 'search-error',
} as const;

export type SearchStatus = ValueOf<typeof SEARCH_STATUSES>;
